$( function () {
  /**
   * 1. CONFIGURATION & ASSETS
   */
  const SVGS = {
    prev: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M13.2929 6.29297L7.58594 12L13.2929 17.707L14.7069 16.293L10.4139 12L14.7069 7.70697L13.2929 6.29297Z" fill="#4E77FC"/></svg>',
    next: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M9.70697 16.9496L15.414 11.2426L9.70697 5.53564L8.29297 6.94964L12.586 11.2426L8.29297 15.5356L9.70697 16.9496Z" fill="#4E77FC"/></svg>',
    article: '<svg class="suggestion-icon" width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.5 9.25H15.5M21.5 4H3.5M21.5 14.75H15.5M21.5 20H3.5M5.1 16H9.9C10.4601 16 10.7401 16 10.954 15.891C11.1422 15.7951 11.2951 15.6422 11.391 15.454C11.5 15.2401 11.5 14.9601 11.5 14.4V9.6C11.5 9.03995 11.5 8.75992 11.391 8.54601C11.2951 8.35785 11.1422 8.20487 10.954 8.10899C10.7401 8 10.4601 8 9.9 8H5.1C4.53995 8 4.25992 8 4.04601 8.10899C3.85785 8.20487 3.70487 8.35785 3.60899 8.54601C3.5 8.75992 3.5 9.03995 3.5 9.6V14.4C3.5 14.9601 3.5 15.2401 3.60899 15.454C3.70487 15.6422 3.85785 15.7951 4.04601 15.891C4.25992 16 4.53995 16 5.1 16Z" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    guide: '<svg class="suggestion-icon" width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 21L12.3999 20.8499C11.7053 19.808 11.358 19.287 10.8991 18.9098C10.4929 18.5759 10.0248 18.3254 9.52161 18.1726C8.95325 18 8.32711 18 7.07482 18H5.7C4.57989 18 4.01984 18 3.59202 17.782C3.21569 17.5903 2.90973 17.2843 2.71799 16.908C2.5 16.4802 2.5 15.9201 2.5 14.8V6.2C2.5 5.07989 2.5 4.51984 2.71799 4.09202C2.90973 3.71569 3.21569 3.40973 3.59202 3.21799C4.01984 3 4.57989 3 5.7 3H6.1C8.34021 3 9.46031 3 10.316 3.43597C11.0686 3.81947 11.6805 4.43139 12.064 5.18404C12.5 6.03968 12.5 7.15979 12.5 9.4M12.5 21V9.4M12.5 21L12.6001 20.8499C13.2947 19.808 13.642 19.287 14.1009 18.9098C14.5071 18.5759 14.9752 18.3254 15.4784 18.1726C16.0467 18 16.6729 18 17.9252 18H19.3C20.4201 18 20.9802 18 21.408 17.782C21.7843 17.5903 22.0903 17.2843 22.282 16.908C22.5 16.4802 22.5 15.9201 22.5 14.8V6.2C22.5 5.07989 22.5 4.51984 22.282 4.09202C22.0903 3.71569 21.7843 3.40973 21.408 3.21799C20.9802 3 20.4201 3 19.3 3H18.9C16.6598 3 15.5397 3 14.684 3.43597C13.9314 3.81947 13.3195 4.43139 12.936 5.18404C12.5 6.03968 12.5 7.15979 12.5 9.4" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    video: '<svg class="suggestion-icon" width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 8.96533C10 8.48805 10 8.24941 10.0997 8.11618C10.1867 8.00007 10.3197 7.92744 10.4644 7.9171C10.6304 7.90525 10.8311 8.03429 11.2326 8.29239L15.9532 11.3271C16.3016 11.551 16.4758 11.663 16.5359 11.8054C16.5885 11.9298 16.5885 12.0702 16.5359 12.1946C16.4758 12.337 16.3016 12.449 15.9532 12.6729L11.2326 15.7076C10.8311 15.9657 10.6304 16.0948 10.4644 16.0829C10.3197 16.0726 10.1867 15.9999 10.0997 15.8838C10 15.7506 10 15.512 10 15.0347V8.96533Z" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  }

  /**
   * Mapping configuration: defines which Google autocomplete dropdown element
   * goes into which local container.
   */
  const PLACEMENT_MAP = [
    { selector: '.gstl_51.gssb_c', target: '.search-form-container' },
    { selector: '.gstl_52.gssb_c', target: '.search-container' }
  ]


  /**
   * 2. UTILITIES & PAGINATION HELPERS
   */
  const convertToSlug = ( text ) => {
    return ( text || '' )
      .toString()
      .toLowerCase()
      .trim()
      .replace( /\s+/g, '-' )
      .replace( /[^\w-]+/g, '' )
      .replace( /--+/g, '-' )
  }

  /**
   * Evaluates text to determine its matching category icon and refinement slug.
   * Matches the design categories:
   * - Video & Multimedia: video, tutorial, magazine, flipbook, animation, course, etc. -> 'youtube' or 'ajar-academy'
   * - Docs & Guides: how to, guide, settings, best practices, doc, help, troubleshoot, etc. -> 'knowledge-base'
   * - Q&A & Forum: q&a, questions, answers, forum -> 'qa'
   * - Articles & Blog: overview, export, articles (default) -> 'blog'
   */
  const categorizeSuggestion = ( text ) => {
    const lower = ( text || '' ).toLowerCase().trim()

    // 1. YouTube / Videos
    if (
      lower.startsWith( '[youtube]' ) ||
      lower.startsWith( '[video]' ) ||
      /\b(youtube|video|magazine|flipbook|animation|demo|watch)\b/i.test( lower )
    ) {
      return { icon: SVGS.video, slug: 'youtube' }
    }

    // 2. Ajar Academy / Courses
    if (
      lower.startsWith( '[academy]' ) ||
      lower.startsWith( '[course]' ) ||
      /\b(course|academy|tutorial|webinar|lesson)\b/i.test( lower )
    ) {
      return { icon: SVGS.video, slug: 'ajar-academy' }
    }

    // 3. Q&A / Community answers
    if (
      lower.startsWith( '[qa]' ) ||
      lower.startsWith( '[q&a]' ) ||
      /\b(q&a|forum|question|questions|answers)\b/i.test( lower )
    ) {
      return { icon: SVGS.guide, slug: 'qa' }
    }

    // 4. Knowledge Base / Docs / Guides
    if (
      lower.startsWith( '[doc]' ) ||
      lower.startsWith( '[guide]' ) ||
      lower.startsWith( '[help]' ) ||
      /\b(how to|guide|settings|best practice|practices|doc|docs|help|troubleshoot|faq|error|install|support|setup|requirement|licensing|seo|cache)\b/i.test( lower )
    ) {
      return { icon: SVGS.guide, slug: 'knowledge-base' }
    }

    // 5. Articles / Blog / Feature overview (default)
    return { icon: SVGS.article, slug: 'blog' }
  }

  /**
   * Pending refinement category to activate when search results render.
   */
  let pendingRefinementSlug = null
  let pendingTimer = null

  const setPendingRefinement = ( slug ) => {
    if ( !slug ) return
    pendingRefinementSlug = slug
    clearTimeout( pendingTimer )
    // Expire after 5 seconds if results never render
    pendingTimer = setTimeout( () => {
      pendingRefinementSlug = null
    }, 5000 )
  }

  /**
   * Finds the Google CSE refinement tab matching the target category slug.
   */
  const findRefinementTab = ( targetSlug ) => {
    const $headers = $( '.gsc-refinementHeader' )
    if ( !$headers.length || !targetSlug ) return null

    // 1. Direct slug match
    for ( let i = 0; i < $headers.length; i++ ) {
      const el = $headers[ i ]
      const text = $( el ).text().trim()
      const slug = convertToSlug( text )
      if ( slug === targetSlug ) {
        return el
      }
    }

    // 2. Keyword fallback match
    for ( let i = 0; i < $headers.length; i++ ) {
      const el = $headers[ i ]
      const text = $( el ).text().trim().toLowerCase()

      if (
        ( targetSlug === 'youtube' && ( text.includes( 'youtube' ) || text.includes( 'video' ) ) ) ||
        ( targetSlug === 'ajar-academy' && ( text.includes( 'academy' ) || text.includes( 'course' ) ) ) ||
        ( targetSlug === 'knowledge-base' && ( text.includes( 'knowledge' ) || text.includes( 'base' ) || text.includes( 'doc' ) || text.includes( 'guide' ) ) ) ||
        ( targetSlug === 'qa' && ( text.includes( 'q&a' ) || text.includes( 'answer' ) || text.includes( 'qa' ) ) ) ||
        ( targetSlug === 'blog' && ( text.includes( 'blog' ) || text.includes( 'article' ) ) )
      ) {
        return el
      }
    }

    // 3. Fallback for video/media if specific tab not found: try YouTube or Ajar Academy
    if ( targetSlug === 'youtube' || targetSlug === 'ajar-academy' ) {
      for ( let i = 0; i < $headers.length; i++ ) {
        const el = $headers[ i ]
        const text = $( el ).text().trim().toLowerCase()
        if ( text.includes( 'youtube' ) || text.includes( 'video' ) || text.includes( 'academy' ) ) {
          return el
        }
      }
    }

    // 4. Fallback for guide/docs if specific tab not found: try Knowledge Base
    if ( targetSlug === 'knowledge-base' || targetSlug === 'qa' ) {
      for ( let i = 0; i < $headers.length; i++ ) {
        const el = $headers[ i ]
        const text = $( el ).text().trim().toLowerCase()
        if ( text.includes( 'knowledge' ) || text.includes( 'help' ) || text.includes( 'q&a' ) ) {
          return el
        }
      }
    }

    return null
  }

  /**
   * Activates the pending refinement tab on the visible results page.
   */
  const applyPendingRefinement = () => {
    if ( !pendingRefinementSlug ) return false

    const tabEl = findRefinementTab( pendingRefinementSlug )
    if ( !tabEl ) return false

    const $tab = $( tabEl )
    if ( !$tab.hasClass( 'gsc-refinementhActive' ) ) {
      if ( typeof tabEl.click === 'function' ) {
        tabEl.click()
      }
      const $span = $tab.find( 'span' )
      if ( $span.length && typeof $span[ 0 ].click === 'function' ) {
        $span[ 0 ].click()
      }
      $tab.trigger( 'click' )
    }

    // Also synchronize any radio refinement filter buttons if present
    const cleanLabel = $tab.text().trim().toLowerCase()
    $( '.refinements-filters input[name="refinement"]' ).each( function () {
      if ( $( this ).val().trim().toLowerCase() === cleanLabel ) {
        $( this ).prop( 'checked', true )
      }
    } )

    pendingRefinementSlug = null
    clearTimeout( pendingTimer )
    return true
  }

  /**
   * Formats Google CSE autocomplete suggestion items by injecting
   * their matching category outline icon and saving their category slug.
   */
  const formatAutocompleteSuggestions = () => {
    $( '.gssb_c' ).each( function () {
      const $container = $( this )
      $container.find( '.gssb_a' ).each( function () {
        const $cell = $( this )
        const $target = $cell.find( '.gsq_a' ).length ? $cell.find( '.gsq_a' ) : $cell

        if ( $target.children( '.suggestion-icon' ).length ) return

        const rawText = $target.text().trim()
        if ( !rawText ) return

        const { icon, slug } = categorizeSuggestion( rawText )
        $target.attr( 'data-category-slug', slug ).data( 'category-slug', slug )
        $cell.attr( 'data-category-slug', slug ).data( 'category-slug', slug )
        $cell.closest( 'tr' ).attr( 'data-category-slug', slug ).data( 'category-slug', slug )

        $target.prepend( icon )
      } )
    } )
  }


  /**
   * Safely dispatches a click to a Google CSE page element.
   * If the element was hidden by our sliding window, we temporarily display it
   * so offsetParent/visibility checks in Google's internal code succeed.
   */
  const triggerPageClick = ( pageEl ) => {
    if ( !pageEl ) return

    const $el = $( pageEl )
    const wasHidden = $el.css( 'display' ) === 'none' || $el.hasClass( 'hide' )

    if ( wasHidden ) {
      $el.css( { display: 'flex', visibility: 'visible' } ).removeClass( 'hide' )
    }

    if ( typeof pageEl.click === 'function' ) {
      pageEl.click()
    } else {
      $el.trigger( 'click' )
    }
  }

  /**
   * Dynamic page navigation for Prev and Next buttons.
   * Evaluates the active page at the exact moment of click (avoids stale closures).
   */
  let isNavigating = false
  const navigatePage = ( $cursor, direction ) => {
    if ( isNavigating ) return

    const $pages = $cursor.find( '.gsc-cursor-page' ).not( '.custom-nav-btn' )
    const totalPages = $pages.length
    if ( !totalPages ) return

    const $currentPage = $pages.filter( '.gsc-cursor-current-page' )
    let currentIndex = $pages.index( $currentPage )
    if ( currentIndex < 0 ) currentIndex = 0

    const targetIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1
    if ( targetIndex < 0 || targetIndex >= totalPages ) return

    const targetPageEl = $pages.get( targetIndex )
    if ( !targetPageEl ) return

    isNavigating = true
    triggerPageClick( targetPageEl )

    // Scroll overlay back to top for better UX
    const $overlay = $cursor.closest( '.gsc-results-wrapper-overlay' )
    if ( $overlay.length ) {
      $overlay.scrollTop( 0 )
    }

    setTimeout( () => {
      isNavigating = false
    }, 300 )
  }

  /**
   * 3. PAGINATION FORMATTER
   */
  function formatPagination ( $cursorBox ) {
    const $cursor = $cursorBox.find( '.gsc-cursor' )
    if ( !$cursor.length ) return

    // Find numeric page elements (exclude our custom navigation buttons)
    const $pages = $cursor.find( '.gsc-cursor-page' ).not( '.custom-nav-btn' )
    const totalPages = $pages.length

    // If Google hasn't finished rendering the page numbers yet, retry shortly
    if ( !totalPages ) {
      const retryCount = ( $cursor.data( 'gse-retry-count' ) || 0 ) + 1
      if ( retryCount <= 5 ) {
        $cursor.data( 'gse-retry-count', retryCount )
        setTimeout( () => formatPagination( $cursorBox ), 100 )
      }
      return
    }
    $cursor.data( 'gse-retry-count', 0 )

    // If there is only 1 page or none, hide pagination cursor
    if ( totalPages <= 1 ) {
      $cursor.hide()
      return
    }
    $cursor.show()

    // Determine current active page
    const $currentPage = $pages.filter( '.gsc-cursor-current-page' )
    let currentIndex = $pages.index( $currentPage )
    if ( currentIndex < 0 ) {
      currentIndex = 0
      $pages.first().addClass( 'gsc-cursor-current-page' )
    }

    // Check existing custom structure
    let $wrapper = $cursor.children( '.gsc-cursor-number-wrapper' )
    let $prevBtn = $cursor.children( '.prev-btn' )
    let $nextBtn = $cursor.children( '.next-btn' )

    const isStructured = $wrapper.length > 0 && $prevBtn.length > 0 && $nextBtn.length > 0
    const prevActiveIndex = $cursor.data( 'gse-active-index' )
    const prevTotalPages = $cursor.data( 'gse-total-pages' )

    // If already fully formatted and active page / total pages have not changed, nothing to do
    if ( isStructured && prevActiveIndex === currentIndex && prevTotalPages === totalPages ) {
      return
    }

    // 1. Ensure wrapper exists and holds all pages (NEVER delete pages from DOM!)
    if ( !$wrapper.length ) {
      $wrapper = $( '<div>', { class: 'gsc-cursor-number-wrapper pagination-rendered' } )
      $cursor.append( $wrapper )
    }

    $pages.each( function () {
      if ( $( this ).parent()[ 0 ] !== $wrapper[ 0 ] ) {
        $wrapper.append( $( this ) )
      }
    } )

    // 2. Ensure Prev / Next buttons exist
    if ( !$prevBtn.length ) {
      $prevBtn = $( '<div>', {
        class: 'custom-nav-btn prev-btn',
        role: 'button',
        html: `${ SVGS.prev }<span>Prev</span>`
      } )
      $cursor.prepend( $prevBtn )
    }

    if ( !$nextBtn.length ) {
      $nextBtn = $( '<div>', {
        class: 'custom-nav-btn next-btn',
        role: 'button',
        html: `<span>Next</span>${ SVGS.next }`
      } )
      $cursor.append( $nextBtn )
    }

    // 3. Sliding window logic (up to 4 pages)
    let start = Math.max( 0, currentIndex - 1 )
    let end = Math.min( totalPages - 1, start + 3 )
    if ( end === totalPages - 1 ) {
      start = Math.max( 0, end - 3 )
    }

    // Show pages in the 4-page sliding window; hide the rest (do NOT delete them!)
    $pages.each( function ( i ) {
      if ( i >= start && i <= end ) {
        $( this ).css( { display: 'flex', visibility: 'visible' } ).removeClass( 'hide' )
      } else {
        $( this ).css( { display: 'none', visibility: 'hidden' } ).addClass( 'hide' )
      }
    } )

    // 4. Update Prev / Next button states
    const hasPrev = currentIndex > 0
    $prevBtn
      .toggleClass( 'disabled', !hasPrev )
      .attr( 'tabindex', hasPrev ? 0 : -1 )

    const hasNext = currentIndex < totalPages - 1
    $nextBtn
      .toggleClass( 'disabled', !hasNext )
      .attr( 'tabindex', hasNext ? 0 : -1 )

    // Mark rendered classes and cache current state
    $cursor.addClass( 'pagination-rendered' )
    $cursor.data( 'gse-active-index', currentIndex )
    $cursor.data( 'gse-total-pages', totalPages )
  }

  /**
   * 4. DOM REPOSITIONING
   */
  const repositionGoogleElements = () => {
    PLACEMENT_MAP.forEach( ( { selector, target } ) => {
      const $el = $( selector )
      if ( !$el.length ) return

      const $target = $( target )
      if ( $target.length && !$el.parent().is( $target ) ) {
        $target.append( $el )
      }
    } )
  }

  /**
   * 5. INPUT CUSTOMIZATION & GCSE INITIALIZATION
   */
  const customizeSearchInputs = () => {
    const $inputs = $( 'input.gsc-input' )
    if ( !$inputs.length ) return false

    $( '.site-header input.gsc-input' ).attr( 'placeholder', 'Find anything...' )
    $( '.search-section input.gsc-input' ).attr( 'placeholder', 'Search for answers…' )
    $( 'input.gsc-input:not([placeholder])' ).attr( 'placeholder', 'Search…' )

    $( '.gsc-search-button-v2' ).html( 'Search' )
    $( '.search-container' ).removeClass( 'hide' )
    return true
  }

  const pollSearchInputs = () => {
    if ( customizeSearchInputs() ) return

    let attempts = 0
    const maxAttempts = 50 // 5 seconds maximum polling time
    const pollInterval = setInterval( () => {
      attempts++
      if ( customizeSearchInputs() || attempts >= maxAttempts ) {
        clearInterval( pollInterval )
      }
    }, 100 )
  }

  // Configure window.__gcse safely without overwriting
  window.__gcse = window.__gcse || {}
  window.__gcse.parsetags = 'onload'

  const previousInit = window.__gcse.initializationCallback
  window.__gcse.initializationCallback = function () {
    if ( typeof previousInit === 'function' ) {
      previousInit()
    }
    pollSearchInputs()
  }

  /**
   * 6. MUTATION OBSERVER & HANDLERS
   */
  const handleMutations = () => {
    // A. Move Results Overlay to <body>
    const $overlay = $( '.gsc-results-wrapper-overlay' )
    if ( $overlay.length && !$overlay.parent().is( 'body' ) ) {
      $( 'body' ).append( $overlay )
    }

    // B. Handle Visible Results (header & refinement slug classes)
    const $visibleOverlay = $( '.gsc-results-wrapper-visible' )
    if ( $visibleOverlay.length ) {
      if ( !$visibleOverlay.find( '.custom-results-header' ).length ) {
        $visibleOverlay.prepend( '<h2 class="custom-results-header">Search results</h2>' )
      }

      $visibleOverlay.find( '.gsc-refinementHeader span' ).each( function () {
        const $span = $( this )
        const slug = convertToSlug( $span.text() )
        if ( slug && !$span.hasClass( slug ) ) {
          $span.addClass( slug )
        }
      } )

      // Automatically switch to the autocomplete item's category tab
      applyPendingRefinement()
    }

    // C. Format Pagination
    const $cursorBoxes = $( '.gsc-cursor-box' )
    if ( $cursorBoxes.length ) {
      $cursorBoxes.each( function () {
        formatPagination( $( this ) )
      } )
    }

    // D. Reposition Google completion dropdowns
    repositionGoogleElements()

    // E. Format Autocomplete Suggestions
    formatAutocompleteSuggestions()

    // F. Remove the no-suggestion hint if Google's real suggestions arrive late
    removeStaleNoSuggestionHints()

    // G. Sync Active Refinement Filter (only when checked, not already active, and no pending autocomplete refinement)
    if ( !pendingRefinementSlug ) {
      const $activeRadio = $( '.refinements-filters input[name="refinement"]:checked' )
      const activeLabel = $activeRadio.val()
      if ( activeLabel && activeLabel.trim() ) {
        const cleanLabel = activeLabel.trim().toLowerCase()
        const $targetHeader = $( '.gsc-refinementHeader' ).filter( function () {
          return $( this ).text().trim().toLowerCase() === cleanLabel
        } )
        if ( $targetHeader.length && !$targetHeader.hasClass( 'gsc-refinementhActive' ) ) {
          $targetHeader.trigger( 'click' )
        }
      }
    }
  }

  let debounceTimer = null
  const observer = new MutationObserver( () => {
    clearTimeout( debounceTimer )
    debounceTimer = setTimeout( handleMutations, 50 )
  } )

  // Single unified observer on documentElement for both direct children and subtree changes
  observer.observe( document.documentElement, {
    childList: true,
    subtree: true
  } )

  /**
   * 7. EVENT DELEGATION
   */
  // Search icon button click triggers GCSE search
  $( document ).on( 'click', '#search-btn', function ( e ) {
    e.preventDefault()
    const $container = $( this ).closest( '.search-form-container, .search-container, #cse' )
    const $gscBtn = $container.find( '.gsc-search-button-v2, input.gsc-search-button' )

    if ( $gscBtn.length ) {
      $gscBtn.trigger( 'click' )
    } else {
      $container.find( 'input.gsc-input' ).trigger( 'focus' )
    }
  } )

  // Delegated click on Prev button
  $( document ).on( 'click', '.custom-nav-btn.prev-btn', function ( e ) {
    e.preventDefault()
    if ( $( this ).hasClass( 'disabled' ) ) return
    const $cursor = $( this ).closest( '.gsc-cursor' )
    navigatePage( $cursor, 'prev' )
  } )

  // Delegated click on Next button
  $( document ).on( 'click', '.custom-nav-btn.next-btn', function ( e ) {
    e.preventDefault()
    if ( $( this ).hasClass( 'disabled' ) ) return
    const $cursor = $( this ).closest( '.gsc-cursor' )
    navigatePage( $cursor, 'next' )
  } )

  // Keyboard navigation for custom buttons
  $( document ).on( 'keydown', '.custom-nav-btn', function ( e ) {
    if ( e.key === 'Enter' || e.key === ' ' ) {
      e.preventDefault()
      $( this ).trigger( 'click' )
    }
  } )

  // Refinement filter radio selection changes
  $( document ).on( 'change', '.refinements-filters input[name="refinement"]', function () {
    const label = $( this ).val()
    if ( !label || !label.trim() ) return
    const cleanLabel = label.trim().toLowerCase()

    const $targetHeader = $( '.gsc-refinementHeader' ).filter( function () {
      return $( this ).text().trim().toLowerCase() === cleanLabel
    } )

    if ( $targetHeader.length && !$targetHeader.hasClass( 'gsc-refinementhActive' ) ) {
      $targetHeader.trigger( 'click' )
    }
  } )

  // Google autocomplete suggestion mousedown - capture category to switch result tab
  $( document ).on( 'mousedown', '.gssb_c tr', function () {
    const $row = $( this )
    const $target = $row.find( '.gsq_a' ).length ? $row.find( '.gsq_a' ) : $row.find( '.gssb_a' )
    const slug = $target.data( 'category-slug' ) || $row.data( 'category-slug' )

    if ( slug ) {
      setPendingRefinement( slug )
    } else {
      const text = $target.text().trim()
      if ( text ) {
        const { slug: detectedSlug } = categorizeSuggestion( text )
        setPendingRefinement( detectedSlug )
      }
    }
  } )

  // Google autocomplete Enter selection - capture category to switch result tab
  $( document ).on( 'keydown', 'input.gsc-input', function ( e ) {
    if ( e.key === 'Enter' ) {
      const $selected = $( '.gssb_c tr.gsc-completion-selected' )
      if ( $selected.length ) {
        const $target = $selected.find( '.gsq_a' ).length ? $selected.find( '.gsq_a' ) : $selected.find( '.gssb_a' )
        const slug = $target.data( 'category-slug' ) || $selected.data( 'category-slug' )
        if ( slug ) {
          setPendingRefinement( slug )
        } else {
          const text = $target.text().trim()
          if ( text ) {
            const { slug: detectedSlug } = categorizeSuggestion( text )
            setPendingRefinement( detectedSlug )
          }
        }
      }
    }
  } )

  /**
   * 8. NO-SUGGESTION FALLBACK HINT
   * Google's autocomplete suggestions come from search-query popularity data,
   * not a live match against indexed content, so a valid query can return zero
   * suggestions even though it matches real results once searched. When that
   * happens, show a lightweight "Search for '...'" hint instead of leaving
   * the dropdown empty.
   */
  const NO_SUGGESTION_HINT_CLASS = 'gse-no-suggestion-hint'
  let noSuggestionTimer = null

  const removeNoSuggestionHint = ( $container ) => {
    $container.find( `.${ NO_SUGGESTION_HINT_CLASS }` ).remove()
  }

  // Google's suggestion request can resolve after our own no-suggestion check
  // already ran, so re-check on every DOM mutation and drop the hint as soon
  // as the real dropdown actually has rows, instead of leaving both visible.
  const removeStaleNoSuggestionHints = () => {
    $( `.${ NO_SUGGESTION_HINT_CLASS }` ).each( function () {
      const $hint = $( this )
      const $container = $hint.parent()
      const $visibleBoxes = $container.find( '.gssb_c' ).filter( function () {
        return $( this ).is( ':visible' )
      } )
      if ( $visibleBoxes.find( '.gssb_a' ).length > 0 ) {
        $hint.remove()
      }
    } )
  }

  // Mirrors how Google positions its own autocomplete box: measured off the
  // input's actual on-screen rect rather than a hardcoded offset, since the
  // container element (.search-form-container in particular) is often a much
  // smaller wrapper than the visible input it holds.
  const positionNoSuggestionHint = ( $hint, $input, $container ) => {
    const inputRect = $input[ 0 ].getBoundingClientRect()
    const gap = 16

    if ( $container.hasClass( 'search-form-container' ) ) {
      $hint.css( {
        position: 'fixed',
        top: inputRect.bottom + gap,
        left: inputRect.left
      } )
    } else if ( $container.hasClass( 'search-container' ) ) {
      const containerRect = $container[ 0 ].getBoundingClientRect()
      $hint.css( {
        position: 'absolute',
        top: inputRect.bottom - containerRect.top + gap,
        left: inputRect.left - containerRect.left
      } )
    } else {
      $hint.css( {
        position: 'absolute',
        top: inputRect.bottom + window.scrollY + gap,
        left: inputRect.left + window.scrollX
      } )
    }
  }

  const showNoSuggestionHint = ( $input, $container, query ) => {
    removeNoSuggestionHint( $container )

    const $hint = $( '<div>', {
      class: NO_SUGGESTION_HINT_CLASS,
      role: 'button',
      tabindex: 0,
      text: `Search for "${ query }"`
    } )

    $hint.on( 'mousedown', function ( e ) {
      e.preventDefault()
      const $gscBtn = $container.find( '.gsc-search-button-v2, input.gsc-search-button' )
      if ( $gscBtn.length ) {
        $gscBtn.trigger( 'click' )
      }
    } )

    $container.append( $hint )
    positionNoSuggestionHint( $hint, $input, $container )
  }

  const checkForNoSuggestions = ( $input, $container ) => {
    const query = $input.val().trim()
    if ( !query ) {
      removeNoSuggestionHint( $container )
      return
    }

    const $visibleBoxes = $container.find( '.gssb_c' ).filter( function () {
      return $( this ).is( ':visible' )
    } )
    const hasSuggestions = $visibleBoxes.find( '.gssb_a' ).length > 0

    if ( hasSuggestions ) {
      removeNoSuggestionHint( $container )
    } else {
      showNoSuggestionHint( $input, $container, query )
    }
  }

  // Wait for Google's own suggestion request to resolve before deciding
  // there are none, then show the fallback hint if the dropdown stayed empty.
  $( document ).on( 'input', 'input.gsc-input', function () {
    const $input = $( this )
    const $container = $input.closest( '.search-form-container, .search-container, #cse' )
    if ( !$container.length ) return

    removeNoSuggestionHint( $container )
    clearTimeout( noSuggestionTimer )
    noSuggestionTimer = setTimeout( () => checkForNoSuggestions( $input, $container ), 500 )
  } )

  // Give a click on the hint time to register before it gets removed on blur.
  $( document ).on( 'blur', 'input.gsc-input', function () {
    const $container = $( this ).closest( '.search-form-container, .search-container, #cse' )
    if ( !$container.length ) return
    setTimeout( () => removeNoSuggestionHint( $container ), 150 )
  } )

  /**
   * 9. INITIAL RUN
   */
  pollSearchInputs()
  repositionGoogleElements()
  formatAutocompleteSuggestions()
  handleMutations()
} )